export default "__VITE_ASSET__ZByKvwAZ__"